var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { MessageStatus } from '../messageStatus';
import transferTypes from './utils/transferTypes';
export default class StatusTransferStarted extends PureComponent {
    constructor(props) {
        super(props);
    }
    generateStatusText(transfer_type, transfer_target_name) {
        const targetName = transfer_target_name ? ` "${transfer_target_name}"` : '';
        return `${transferTypes.getTypeString(transfer_type)}${targetName} started`;
    }
    render() {
        const _a = this.props, { message } = _a, otherProps = __rest(_a, ["message"]);
        return (_jsx(MessageStatus, Object.assign({}, otherProps, { text: this.generateStatusText(message.transfer_type, message.transfer_target_name) })));
    }
}
